module.exports = ".pointer-cursor {\n  cursor: pointer; }\n\n.text-secondary {\n  color: #c8ced3 !important; }\n\n.no-border-top {\n  border-top: 0px; }\n\n.center-text {\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/youtube-video/video-results/video-results.component.scss
// module id = ./src/app/youtube-video/video-results/video-results.component.scss
// module chunks = main